import { __extends, __rest } from "tslib";
import * as React from 'react';
import { StyleSheet, View } from 'react-native';
import Caption from '../Typography/PnmacCaption';
import Title from '../Typography/PnmacTitle';
var LEFT_SIZE = 40;
/**
 * A component to show a title, subtitle and an avatar inside a Card.
 *
 * <div class="screenshots">
 *   <img class="medium" src="screenshots/card-title-1.png" />
 * </div>
 *
 * ## Usage
 * ```js
 * import * as React from 'react';
 * import { PnmacAvatar, PnmacCard, PnmacIconButton } from 'pnmac-universal-components';
 *
 * const MyComponent = () => (
 *   <PnmacCard.Title
 *     title="Card Title"
 *     subtitle="Card Subtitle"
 *     left={(props) => <Avatar.Icon {...props} icon="folder" />}
 *     right={(props) => <IconButton {...props} icon="more-vert" onPress={() => {}} />}
 *   />
 * );
 *
 * export default MyComponent;
 * ```
 */
var PnmacCardTitle = /** @class */function (_super) {
  __extends(PnmacCardTitle, _super);
  function PnmacCardTitle() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  PnmacCardTitle.prototype.render = function () {
    var _a = this.props,
      left = _a.left,
      leftStyle = _a.leftStyle,
      right = _a.right,
      rightStyle = _a.rightStyle,
      subtitle = _a.subtitle,
      subtitleStyle = _a.subtitleStyle,
      subtitleNumberOfLines = _a.subtitleNumberOfLines,
      titleNumberOfLines = _a.titleNumberOfLines,
      style = _a.style,
      title = _a.title,
      titleStyle = _a.titleStyle,
      rest = __rest(_a, ["left", "leftStyle", "right", "rightStyle", "subtitle", "subtitleStyle", "subtitleNumberOfLines", "titleNumberOfLines", "style", "title", "titleStyle"]);
    return /*#__PURE__*/React.createElement(View, {
      style: [styles.container, {
        minHeight: subtitle || left || right ? 72 : 50
      }, style],
      nativeID: rest.idTag1,
      accessibilityLevel: rest.accessibilityLevel,
      accessibilityRole: rest.accessibilityRole
    }, left ? (/*#__PURE__*/React.createElement(View, {
      style: [styles.left, leftStyle],
      nativeID: rest.idTag2
    }, left({
      size: LEFT_SIZE
    }))) : null, /*#__PURE__*/React.createElement(View, {
      style: [styles.titles],
      nativeID: rest.idTag3
    }, title ? (/*#__PURE__*/React.createElement(Title, {
      style: [styles.title, {
        marginBottom: subtitle ? 0 : 2
      }, titleStyle],
      numberOfLines: titleNumberOfLines,
      nativeID: rest.idTag4
    }, title)) : null, subtitle ? (/*#__PURE__*/React.createElement(Caption, {
      style: [styles.subtitle, subtitleStyle],
      numberOfLines: subtitleNumberOfLines,
      nativeID: rest.idTag5
    }, subtitle)) : null), /*#__PURE__*/React.createElement(View, {
      style: rightStyle,
      nativeID: rest.idTag6
    }, right ? right({
      size: 24
    }) : null));
  };
  PnmacCardTitle.displayName = 'PnmacCard.Title';
  PnmacCardTitle.defaultProps = {
    subtitleNumberOfLines: 1,
    titleNumberOfLines: 2
  };
  return PnmacCardTitle;
}(React.Component);
var styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    paddingLeft: 16
  },
  left: {
    justifyContent: 'center',
    marginRight: 16,
    height: LEFT_SIZE,
    width: LEFT_SIZE
  },
  titles: {
    flex: 1,
    flexDirection: 'column',
    justifyContent: 'center'
  },
  title: {
    minHeight: 30
  },
  subtitle: {
    minHeight: 20,
    marginVertical: 0
  }
});
export default PnmacCardTitle;